<template>
  <v-card
    max-width="1000"
    class="rounded-0 mx-auto"
    :disabled="loading"
    :loading="loading"
  >
    <v-toolbar id="section-9" color="black" flat>
      <v-toolbar-title>
        <h1>{{ $t("info_card.title_page9") }}</h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text
      class="pa-0 pa-sm-3 pa-xl-6 my-5"
      v-for="(item, index) in renderedDocumentData"
      :key="index"
    >
      <h3>
        {{ index + 1 }}.
        {{ objectTranslator(item, "DOCUMENT_TYPE_NAME") }}
      </h3>

      <v-chip
        :color="getUploadStatusChipColor(item.UPLOAD_STATUS_ID)"
        :append-icon="getUploadStatusChipIcon(item.UPLOAD_STATUS_ID)"
        v-if="
          item.REQUIRED === '1' ||
          (item.REQUIRED === '0' && item.UPLOAD_STATUS_ID !== '1')
        "
      >
        <h6>{{ objectTranslator(item, "UPLOAD_STATUS_NAME") }}</h6>
      </v-chip>

      <v-row>
        <v-col
          cols="12"
          v-for="(item2, index2) in item.currentFiles"
          :key="index2"
        >
          <v-card variant="outlined" elevation="0" class="pa-3">
            <p>
              {{ $t("upload.file") }}: {{ index2 + 1 }}/{{
                item.currentFiles.length
              }}
            </p>

            <a
              :href="item2.src"
              target="_blank"
              v-if="item2.type == 'application/pdf'"
            >
              <v-btn
                class="mb-1 float-right"
                color="error"
                variant="outlined"
                prepend-icon="mdi-file-pdf-box"
                elevation="0"
              >
                {{ $t("upload.view_file") }}
              </v-btn>
            </a>

            <embed
              :src="item2.src"
              width="100%"
              height="500px"
              type="application/pdf"
              v-if="item2.type == 'application/pdf'"
            />

            <PrimeVueImage :src="item2.src" v-else />
          </v-card>
        </v-col>
        <v-col v-if="item.currentFiles && item.currentFiles.length === 0">
          <p class="text-center text-secondary">no file uploaded</p>
        </v-col>
      </v-row>

      <v-chip
        :color="getUploadStatusChipColor(item.UPLOAD_STATUS_ID)"
        :append-icon="getUploadStatusChipIcon(item.UPLOAD_STATUS_ID)"
        v-if="
          item.REQUIRED === '1' ||
          (item.REQUIRED === '0' && item.UPLOAD_STATUS_ID !== '1')
        "
      >
        <h6>{{ objectTranslator(item, "UPLOAD_STATUS_NAME") }}</h6>
      </v-chip>
      <p
        class="bg-red-lighten-5 text-red mb-1"
        v-if="item.COMMENT != '' && item.UPLOAD_STATUS_ID !== '3'"
      >
        {{ $t("upload_doc.correction_details") }}:
        <b>{{ item.COMMENT }}</b>
      </p>
      <div
        class="d-flex justify-center mb-4"
        v-if="item.currentFiles && item.currentFiles.length !== 0"
      >
        <v-btn
          color="success"
          :disabled="renderedDocumentData[index].UPLOAD_STATUS_ID === '3'"
          @click="
            setCommentDoc(item.DOCUMENT_TYPE_ID, '3', item.COMMENT, index)
          "
          >บันทึก:ผ่าน</v-btn
        ><v-btn
          color="error"
          variant="outlined"
          :disabled="renderedDocumentData[index].UPLOAD_STATUS_ID === '4'"
          class="ml-2"
          @click="item.showComment = !item.showComment"
          >ไม่ผ่าน (กดเพื่อระบุ comment)
        </v-btn>
      </div>

      <v-card
        color="grey-lighten-3"
        elevation="3"
        class="pa-3"
        v-if="item.UPLOAD_STATUS_ID === '4' || item.showComment == true"
      >
        <h2 class="pb-1">
          Comment การอัปโหลดเอกสาร : กรอกกรณีนักศึกษาอัปโหลดเอกสารไม่ถูกต้อง
        </h2>
        <v-textarea
          v-model="item.COMMENT"
          class="pa-2"
          clearable
          variant="solo-filled"
        >
        </v-textarea>
        <div class="d-flex justify-center">
          <v-btn
            @click="
              setCommentDoc(item.DOCUMENT_TYPE_ID, '4', item.COMMENT, index)
            "
            color="error"
            >บันทึก:ไม่ผ่าน</v-btn
          >
        </div>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import PrimeVueImage from "@/components/info_cards/PrimeVueImage.vue";
import UploadProvider from "@/services/upload.provider";
import { objectTranslator } from "@/helper/translator";

const uploadProvider = new UploadProvider();

export default {
  name: "OfficerSection",

  components: {
    PrimeVueImage,
  },

  props: {
    fetch_all_lock: Function,
  },

  data: () => ({
    loading: false,

    isCompleteUploadDocument: false,
    documentTypeData: [],
    documentData: [],

    renderedDocumentData: [],

    commentDoc: [],
  }),

  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },

    uploadStatuss() {
      return this.$store.state.ref.uploadStatuss;
    },
  },

  methods: {
    objectTranslator,

    expandComment(INDEX, boolean) {
      this.renderedDocumentData[INDEX].showComment = boolean;
    },

    getUploadStatusChipColor(UPLOAD_STATUS_ID) {
      let color = "";
      switch (UPLOAD_STATUS_ID) {
        case "1":
          color = "black";
          break;
        case "2":
          color = "warning";
          break;
        case "3":
          color = "success";
          break;
        case "4":
          color = "error";
          break;
      }
      return color;
    },

    getUploadStatusChipIcon(UPLOAD_STATUS_ID) {
      let icon = "";
      switch (UPLOAD_STATUS_ID) {
        case "1":
          icon = null;
          break;
        case "2":
          icon = "mdi-clock-outline";
          break;
        case "3":
          icon = "mdi-check-circle-outline";
          break;
        case "4":
          icon = "mdi-close-circle";
          break;
      }
      return icon;
    },

    async fetchData() {
      this.loading = true;

      let data = await uploadProvider
        .getDocumentType({ level_id: this.surrogated_student_info.LEVEL_ID })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (data) {
        if (this.surrogated_student_info.FACULTY_ID == '95') {
          this.documentTypeData = data.filter(item => item.DOCUMENT_TYPE_ID >= 951);
        } else {
          this.documentTypeData = data.filter(item => item.DOCUMENT_TYPE_ID < 951);
        }
      }
      data = await uploadProvider
        .getDocument({ uid: this.uid })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (data) this.documentData = data;

      this.renderedDocumentData = this.documentTypeData.map((item) => {
        let setted = false;

        this.documentData.map(async (item2) => {
          if (item.DOCUMENT_TYPE_ID === item2.DOCUMENT_TYPE_ID) {
            setted = true;
            item.UPLOAD_STATUS_ID = item2.UPLOAD_STATUS_ID;
            item.COMMENT = item2.COMMENT;
            item.currentFiles = await this.getFiles(item.DOCUMENT_TYPE_ID);
            item.showComment = false;
          }
        });

        if (setted === false) {
          item.UPLOAD_STATUS_ID = "1";
          item.COMMENT = "";
          item.currentFiles = [];
        }

        this.uploadStatuss.map((item2) => {
          if (item.UPLOAD_STATUS_ID === item2.UPLOAD_STATUS_ID) {
            item.UPLOAD_STATUS_NAME_TH = item2.UPLOAD_STATUS_NAME_TH;
            item.UPLOAD_STATUS_NAME_EN = item2.UPLOAD_STATUS_NAME_EN;
          }
        });

        return item;
      });
      // this.getCommentDocument();
      this.loading = false;
    },

    async getFiles(DOCUMENT_TYPE_ID) {
      let currentDocumentTypeId = DOCUMENT_TYPE_ID;
      let currentPageCount = null;
      let currentFiles = [];

      const data = await uploadProvider
        .getDocumentPages({
          uid: this.uid,
          DOCUMENT_TYPE_ID: currentDocumentTypeId,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });

      if (data && data.number) {
        currentPageCount = data.number;

        for (let i = 1; i <= currentPageCount; i++) {
          const data = await uploadProvider
            .getDocumentFile({
              uid: this.uid,
              DOCUMENT_TYPE_ID: currentDocumentTypeId,
              PAGE: i,
            })
            .catch((error) => {
              error.response.data.text().then((text) => {
                this.$toast.error(text);
              });
              this.loading = false;
            });
          if (data) {
            currentFiles.push({
              src: window.URL.createObjectURL(data),
              type: data.type,
            });
          }
        }
      }

      return currentFiles;
    },

    // async getCommentDocument() {
    //   const commentDoc = await userService
    //     .getCommentDocument(this.uid)
    //     .catch((error) => {
    //       this.$toast.error(JSON.stringify(error.response.data.message));
    //     });
    //   this.commentDoc = commentDoc;
    // },

    async setCommentDoc(DOCUMENT_TYPE_ID, UPLOAD_STATUS_ID, COMMENT, INDEX) {
      let documentTypeId = DOCUMENT_TYPE_ID;
      let uploadStatusId = UPLOAD_STATUS_ID;
      let comment = COMMENT;
      this.loading = true;
      const response = await uploadProvider
        .commentDocumentFile({
          uid: this.uid,
          DOCUMENT_TYPE_ID: documentTypeId,
          UPLOAD_STATUS_ID: uploadStatusId,
          COMMENT: comment,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (response && response.status) {
        this.$toast.success(this.$t("toast.save_successfully"));
        this.renderedDocumentData[INDEX].UPLOAD_STATUS_ID = uploadStatusId;
        this.uploadStatuss.map((item2) => {
          if (
            this.renderedDocumentData[INDEX].UPLOAD_STATUS_ID ===
            item2.UPLOAD_STATUS_ID
          ) {
            this.renderedDocumentData[INDEX].UPLOAD_STATUS_NAME_TH =
              item2.UPLOAD_STATUS_NAME_TH;
            this.renderedDocumentData[INDEX].UPLOAD_STATUS_NAME_EN =
              item2.UPLOAD_STATUS_NAME_EN;
          }
        });
        this.expandComment(INDEX, false);
        this.fetch_all_lock();
      } else this.$toast.error(this.$t("toast.cannot_save"));
      this.loading = false;
    },
  },

  created() {
    this.$store.dispatch("ref/getUploadStatuss");
    this.fetchData();
  },
};
</script>
<style scoped>
.v-expansion-panel-title {
  display: block !important;
}

.v-expansion-panel-title__icon {
  float: right;
}

.v-expansion-panel-text__wrapper {
  padding: 0px !important;
}

.v-chip {
  margin: 2px;
}
</style>
